import { Injectable } from '@angular/core';
import { ApiService } from './Api.service';

@Injectable({
  providedIn: 'root',
})
export class EnrollmentService {
  constructor(private apiService: ApiService) {}

  /**
   * Send a new public pre-enrollment from the institutional website.
   * POST {api_url}/public/enrollments
   *
   * The body is an object with the enrollment fields; every property is
   * optional on the API side, but the UI enforces the per-level minimum
   * (see SblockEnrollmentFormComponent). Errors propagate so the caller
   * can show feedback to the user.
   */
  createEnrollment(data: { [key: string]: any }) {
    return this.apiService.post('public/enrollments', data);
  }
}
